import { render, staticRenderFns } from "./CabinetLayout.vue?vue&type=template&id=b2c9c3e4"
import script from "./CabinetLayout.vue?vue&type=script&lang=js"
export * from "./CabinetLayout.vue?vue&type=script&lang=js"
import style0 from "./CabinetLayout.vue?vue&type=style&index=0&id=b2c9c3e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports